import { MouseEventHandler } from "react";

import "./EditorSaveButton.scss";

import {RiSave3Line, RiCheckFill} from "react-icons/ri";
import { Spinner } from "@swivl-mono/ui";
interface Props {
    isDirty: boolean;
    isSaving: boolean;
    save:MouseEventHandler|undefined
    canEdit:boolean
}
export function EditorSaveButton(props:Props) {
    const { isDirty, isSaving, save ,canEdit} = props
    if (!canEdit) {return null}
    let content; 
    if (isSaving) { content = <Spinner /> } 
    else if (isDirty) {
        content = <><RiSave3Line/><span>SAVE</span></>
    } else {
        content = <><RiCheckFill/><span>SAVED</span></>
    }

    return  (
    <div 
        className={isDirty || isSaving ? "EditorSaveButton show" : "EditorSaveButton hide"} 
        onClick={isDirty && !isSaving ? save : undefined}>
            {content}
            </div>
        )
}